/**
 * Form handling functionality
 * @module forms
 */

/**
 * Initializes form behavior
 */
export function initializeForms() {
  document.querySelectorAll('.gform_body input[type="text"], .gform_body input[type="email"], .gform_body textarea')
          .forEach(setupFormInput);
}

function setupFormInput(input) {
  checkInput(input);
  ['focus', 'blur'].forEach(event =>
      input.addEventListener(event, () => checkInput(input)));
}

function checkInput(input) {
  const label = input.closest('.gfield')?.querySelector('.gform-field-label');
  if (label) {
    label.classList.toggle('active', input.value !== '' || input === document.activeElement);
  }
}
